import React from 'react';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Tabs, Tab, Paper } from '@material-ui/core';
import { trackActivity } from '../../../utils/mixpanel';
import { red } from '@material-ui/core/colors';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
const ReportsTab = ({ tabIndex = 'portfolio', history }) => {
    return (
        <>
            <DeploymentMessage />
            <Paper square style={{ marginBottom: '10px' }}>
                <Tabs indicatorColor='primary' value={tabIndex} onChange={(event, newValue) => history.push(`/reports/${newValue}`)} className={'no-margin-tab'}>
                    <Tab label='Portfolio' value="portfolio" onClick={() => trackActivity('Portfolio Tab Clicked', { page_title: 'Portfolio', event_type: 'Page Visited', event_desc: 'Clicked on Portfolio Tab from Reports' })} />
                    <Tab label='Engine off Wing' value="engOffWing" onClick={() => trackActivity('Engine off Wing Tab Clicked', { page_title: 'Engine off Wing', event_type: 'Page Visited', event_desc: 'Clicked on Engine off Wing Tab from Reports' })} />
                    <Tab label='Engine Stand/Bag' value="engStandBag" onClick={() => trackActivity('Engine Stand/Bag Tab Clicked', { page_title: 'Engine Stand/Bag', event_type: 'Page Visited', event_desc: 'Clicked on Engine Stand/Bag Tab from Reports' })} />
                    <Tab label='Custom Alerts' value="custom-alerts" onClick={() => trackActivity('Custom Alerts Tab Clicked', { page_title: 'Custom Alerts', event_type: 'Page Visited', event_desc: 'Clicked on Custom Alerts Tab from Reports' })} />

                </Tabs>
            </Paper>
        </>
    )
}
export default withRouter(ReportsTab);